import {Component, ElementRef, Input, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {ReactBaseComponent} from '../../../react/base/react-base.component';
import {
  MaterialVariationMachinePreselect,
} from '../../../react/material/variation/material-variation-machine-preselect';

const containerElementName = 'reactMaterialVariationMachinePreselectModal';

@Component({
  selector: 'material-variation-machine-preselect-modal',
  template: `<div class="inline-block" #${containerElementName}></div>`,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MaterialVariationMachinePreselectModalComponent extends ReactBaseComponent {
  @ViewChild(containerElementName, {static: false}) containerRef: ElementRef;
  @Input() variationId: number;

  constructor() {
    super();
  }

  protected override renderComponent() {
    return <>
      <MaterialVariationMachinePreselect variationId={this.variationId}/>
    </>;
  }
}
